import { render } from "./Login.vue?vue&type=template&id=dc754872&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=dc754872&scoped=true&lang=css"

import exportComponent from "F:\\CS\\Projectsdatabases\\madienty-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc754872"]])

export default __exports__